import Image from "next/image";

import ScreenshotCaseList from "./images/case-list.png";
import ScreenshotProcessingTimeTrend from "./images/processing-time-trend.png";
import ScreenshotVisaBulletinTrend from "./images/visa-bulletin-trend.png";
import {
  FeatureCard,
  DescriptionCard,
  Descriptions,
  DescriptionTitle,
  Heading,
} from "./feature";
import { Feature } from "./feature";

export const Feature1 = () => {
  return (
    <Feature>
      <Heading>
        Start tracking cases with a far more
        <br
          css={`
            display: none;

            @media (min-width: 960px) {
              display: block;
            }
          `}
        />{" "}
        advanced system than government websites
      </Heading>

      <FeatureCard
        title="Case Tracker"
        description="Track all USCIS, NVC, DOL, and EOIR case statuses with a detailed update history and visa trends visualization"
        color="#FEF3C7"
        image={
          <Image
            src={ScreenshotCaseList}
            alt="Screenshot Case List"
            width={993}
            height={612}
            unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
          />
        }
      />

      <Descriptions>
        <DescriptionCard>
          <div
            css={`
              display: flex;
              flex-direction: column;
              gap: 20px;
            `}
          >
            <DescriptionTitle title="USCIS Processing Times Trends" />
            <div
              css={`
                display: flex;
                padding: 0 15px 15px;

                @media (min-width: 960px) {
                  transform: translateY(40px);
                  padding: 0 30px;
                }
              `}
            >
              <Image
                src={ScreenshotProcessingTimeTrend}
                alt="USCIS Processing Times Trends"
                width={1219}
                height={731}
                unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
              />
            </div>
          </div>
        </DescriptionCard>

        <DescriptionCard>
          <div
            css={`
              display: flex;
              flex-direction: column;
              gap: 20px;
            `}
          >
            <DescriptionTitle title="Visa Bulletin Trends" />
            <div
              css={`
                display: flex;
                padding: 0 15px;

                @media (min-width: 960px) {
                  transform: translateX(68px);
                  padding: 0 30px;
                }
              `}
            >
              <Image
                src={ScreenshotVisaBulletinTrend}
                alt="Visa Bulletin Trends"
                width={1214}
                height={774}
                unoptimized={!!process.env.NEXT_PUBLIC_NETLIFY}
              />
            </div>
          </div>
        </DescriptionCard>
      </Descriptions>
    </Feature>
  );
};
